import React from "react";
import { Text } from "@chakra-ui/react";

const LABEL_STYLES = {
  eyebrow: { textStyle: "eyebrow" },
  section: { textStyle: "sectionTitle" },
  muted: { color: "text.muted", fontSize: "sm" },
};

export default function UiLabel({ variant = "eyebrow", ...props }) {
  const styleProps = LABEL_STYLES[variant] || LABEL_STYLES.eyebrow;
  return <Text {...styleProps} {...props} />;
}
